import React, { useEffect } from "react";
import DayPicker from "react-day-picker";
import "react-day-picker/lib/style.css";

export const MobileDayPickerOverlay: React.FC<any> = (props: any) => {
  const { classNames, children } = props;
  // console.log("children", children);

  // function renderDay(day: any) {
  //   const date = day.getDate();
  //   return (
  //     <div style={{height: 30, width: 30}}>
  //       <div>{date}</div>
  //     </div>
  //   );
  // }

//   const bgCatch = `
//   .DayPickerInput-OverlayWrapper::before {
//     content: "";
//     width: 100vw;
//     height: 100vh;
//     display: block;
// }`;

  return (
    <React.Fragment>
      {/* <style>{bgCatch}</style> */}
      <div
        className={`w-100 ${classNames.overlayWrapper}`}
        style={{ backgroundColor: "lightgrey" }}

        {...props}
      >
        <div
        className={`w-100 d-flex justify-content-center ${classNames.overlay}`}
        >
          {children}
          {/* <DayPicker
            {...children.props}
            renderDay={renderDay}
          /> */}
        </div>
      </div>
    </React.Fragment>
  );
}